(function () {
  var PREFECTURES = [
    '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
    '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
    '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
    '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県',
    '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県',
    '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県',
    '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県',
  ];

  function populatePrefectures(root) {
    root.querySelectorAll('[data-ktob-prefecture]').forEach(function (select) {
      if (select.options.length > 1) return;
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = '選択してください';
      select.appendChild(placeholder);
      PREFECTURES.forEach(function (name) {
        var option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        select.appendChild(option);
      });
    });
  }

  function normalizeZip(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function validateForm(form) {
    var zipFields = form.querySelectorAll('[data-ktob-zip]');
    for (var i = 0; i < zipFields.length; i++) {
      var zip = normalizeZip(zipFields[i].value);
      if (zip && zip.length !== 7) {
        return '郵便番号は7桁（ハイフンなし）で入力してください。';
      }
      zipFields[i].value = zip;
    }
    return null;
  }

  function formToObject(form) {
    var data = {};
    new FormData(form).forEach(function (value, key) {
      data[key] = String(value).trim();
    });
    return data;
  }

  function translateRegistrationError(message) {
    var raw = String(message || '').trim();
    if (!raw) return '申請の送信に失敗しました。';
    var m = raw.toLowerCase();
    if (m.indexOf('already been taken') !== -1) {
      return 'このメールアドレスは既に登録されています。';
    }
    if (m.indexOf('incorrect email or password') !== -1 || m.indexOf('invalid email or password') !== -1) {
      return 'メールアドレスまたはパスワードが正しくありません。';
    }
    if (m.indexOf('not found') !== -1) {
      return '入力されたメールアドレスは登録されていません。';
    }
    if (m.indexOf('valid email') !== -1 || m.indexOf('email is invalid') !== -1) {
      return '有効なメールアドレスを入力してください。';
    }
    if (m.indexOf('phone is invalid') !== -1 || m.indexOf('invalid phone') !== -1) {
      return '有効な電話番号を入力してください。';
    }
    if (m.indexOf('blank') !== -1 || m.indexOf('required') !== -1 || /必須/.test(raw)) {
      return raw.indexOf('必須') !== -1 ? raw : '必須項目が入力されていません。';
    }
    if (m.indexOf('is invalid') !== -1) {
      return '入力内容に誤りがあります。';
    }
    return raw;
  }

  function hideFormStatuses(root) {
    root.querySelectorAll('[data-ktob-registration-form-status]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    var globalStatus = root.querySelector('[data-ktob-registration-status]');
    if (globalStatus) {
      globalStatus.hidden = true;
      globalStatus.textContent = '';
    }
  }

  function showStatus(root, form, message, type) {
    hideFormStatuses(root);
    var status =
      (form && form.querySelector('[data-ktob-registration-form-status]')) ||
      root.querySelector('[data-ktob-registration-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    status.className = 'ktob-registration__status ktob-registration__form-status ktob-registration__status--' + type;
    status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function initRegistration(root) {
    if (!root || root.getAttribute('data-ktob-registration-init') === '1') return;
    root.setAttribute('data-ktob-registration-init', '1');

    populatePrefectures(root);

    var panels = root.querySelectorAll('[data-ktob-register-panel]');
    panels.forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        if (!panel.open) return;
        panels.forEach(function (other) {
          if (other !== panel) other.open = false;
        });
      });
    });

    root.querySelectorAll('[data-ktob-register-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var validationError = validateForm(form);
        if (validationError) {
          showStatus(root, form, validationError, 'error');
          return;
        }

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch(root.getAttribute('data-proxy-url') || '/apps/b2b-gate', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formToObject(form)),
        })
          .then(function (res) {
            return res.json().then(function (body) {
              return { ok: res.ok, body: body };
            });
          })
          .then(function (result) {
            if (!result.ok || !result.body.ok) {
              throw new Error(translateRegistrationError(result.body.error || '申請の送信に失敗しました。'));
            }
            form.reset();
            populatePrefectures(root);
            showStatus(
              root,
              form,
              result.body.message ||
                '確認メールを送信しました。メール内のリンクをクリックして、メールアドレスの確認を完了してください。',
              'success',
            );
          })
          .catch(function (error) {
            showStatus(root, form, translateRegistrationError(error.message), 'error');
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ktob-registration-root]').forEach(initRegistration);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ktob-registration-root]');
    if (root) initRegistration(root);
  });
})();
